import jQuery from "jquery";
window.jQuery = jQuery;
var $ = require("jquery");

$ = jQuery;
import "intl-tel-input";

// Javascript for Promotional Webinar System

import { getCurrenLocaleObj } from "../functions";

$(function() {
    const currenLocaleObj = getCurrenLocaleObj();
    var chatMessageDirection = ($(window).width() < 992) ? 'top' : 'bottom';

    // SiGN UP PAGE
    // model sign up pop up control
    $(document).on("touch click", ".js-promotionalWebinarPopup", function(e) {
        e.preventDefault();
        $("#RegisterForPromotionalWebinarModal").modal();
    });

    // page refresh
    // also using this for the member Webinar Code
    var webinarPromotionalLive2 = ($('.WebinarPromotional--live2').length ? $('.WebinarPromotional--live2') : $('.WebinarPromotional--live3')),
        $promotionalPage = $(".PromotionalWebinarPage, .js-memberWebinar");
    if ($promotionalPage.length && !webinarPromotionalLive2.length) {
        var pageState = $promotionalPage.data("pagestate");
        var pageID = $promotionalPage.data("pageid");
        var pageClass = $promotionalPage.data("pageclass");
        //console.log(pageState + " " + pageID + " " + pageClass);
        if (pageState && pageID && pageClass) {
            var interval = setInterval(function() {
                $.get("/promowebinar/state/" + pageClass + "/" + pageID, 'l=' + currenLocaleObj.locale, function(state) {
                    // refreshing the page if the state changed form not live to live or vise vera
                    //console.log(state);
                    if (state != pageState) {
                        clearInterval(interval);
                        window.location.reload(true);
                    }
                });
            }, 30000); // 30 sec  refresh
        }
    }

    if (webinarPromotionalLive2.length) {

        $('.fbshare-button').on('touch click', function () {
            var $this = $(this),
                url = $this.data('url');

            window.open(url);
        });

        var pageID = webinarPromotionalLive2.data('pageid'),
            pageClass = webinarPromotionalLive2.data('pageclass'),
            fbshareBox = $('.fbshare-box'),
            courseSalesBox = $('.course-sales-box'),
            firstElementOldMarginTop = false,
            newMessagePromptButton = $('#js-newMessagePrompt'),
            newMessagePromptPositionDefaultValue = 14;

        if (fbshareBox.length && courseSalesBox.length) {
            var chatPopupCheck = function() {
                var timeStamp = Math.floor(Date.now() / 1000);
                $.get('/promowebinar/chatPopupCheck/' + pageClass + '/' + pageID, '_=' + timeStamp + '&l=' + currenLocaleObj.locale, function(data) {
                    var messageElements = $('.live-chat .panel .panel-body .chat-content .messages *'),
                        firstElement = messageElements.first();

                    if (firstElement.length) {
                        if (firstElementOldMarginTop === false) {
                            firstElementOldMarginTop = parseInt(firstElement.css('margin-top').replace(/[^0-9]/g, ''));
                            if (isNaN(firstElementOldMarginTop)) firstElementOldMarginTop = 0;
                        }
                    }

                    if (data.status == 1) {
                        if ((data.ChatPopupBox == 'Sales') && (data.ChatPopupBoxSalesButtonUrl != null) && (data.ChatPopupBoxSalesButtonText != null)) {
                            fbshareBox.hide();
                            courseSalesBox.show();
                            $('#ChatPopupBoxSalesButton').attr('href', data.ChatPopupBoxSalesButtonUrl);
                            $('#ChatPopupBoxSalesButton').html(data.ChatPopupBoxSalesButtonText);
                            if (firstElement.length) {
                                let outerHeight = courseSalesBox.outerHeight(true),
                                    marginTop = outerHeight + firstElementOldMarginTop,
                                    newMessagePromptPositionValue = outerHeight + 5;

                                firstElement.css('margin-top', marginTop + 'px');

                                if (chatMessageDirection === 'top') {
                                    newMessagePromptButton.css('top', newMessagePromptPositionValue + 'px');
                                }
                            }
                        } else if (data.ChatPopupBox == 'Facebook Share') {
                            fbshareBox.show();
                            courseSalesBox.hide();
                            if (firstElement.length) {
                                let outerHeight = fbshareBox.outerHeight(true),
                                    marginTop = outerHeight + firstElementOldMarginTop,
                                    newMessagePromptPositionValue = outerHeight + 5;

                                firstElement.css('margin-top', marginTop + 'px');

                                if (chatMessageDirection === 'top') {
                                    newMessagePromptButton.css('top', newMessagePromptPositionValue + 'px');
                                }
                            }
                        } else {
                            fbshareBox.hide();
                            courseSalesBox.hide();
                            if (firstElement.length && firstElementOldMarginTop) {
                                firstElement.css('margin-top', firstElementOldMarginTop + 'px');
                            }

                            if (chatMessageDirection === 'top') {
                                newMessagePromptButton.css('top', newMessagePromptPositionDefaultValue + 'px');
                            }
                        }
                    }

                }, 'json');
            };

            // Check in as soon as the page loads (so short visits still record
            // the attendee's arrival) then every 20 secs after that
            chatPopupCheck();
            var intervalChatPopupCheck = setInterval(chatPopupCheck, 20000); // 20 sec  refresh
        }
    }

    // send  pushcrew id to add it to the member
    if ($(".PromotionalWebinarPage_thankyou").length) {

        //console.log('Thank you block running');
        window._pcq.push(["APIReady", callbackOnSuccessFunction]);

        function callbackOnSuccessFunction() {
            //now api is ready //
            var segment = window.pushcrewSegment || "test";
            //var segment = 'test';

            if (pushcrew && pushcrew.hasOwnProperty("subscriberId")) {
                //console.log('found subscribed id ' + pushcrew.subscriberId);
                // could add multiple here
                _pcq.push(["addSubscriberToSegment", segment]);
                _pcq.push(["addSubscriberToSegment", "allpromoWebinar"]);
                saveSubrscriberID(pushcrew.subscriberId);
            }

            window._pcq.push(["subscriptionSuccessCallback", callbackFunctionOnSuccessfulSubscription]);
            window._pcq.push(["triggerOptIn", { subscriberSegment: segment }]);
        }

        function callbackFunctionOnSuccessfulSubscription(subscriberId, values) {
            //console.log('User got successfully subscribed.' + subscriberId);
            saveSubrscriberID(subscriberId);
        }

        function saveSubrscriberID(id) {
            if (id !== false && id !== -1) {
                $.post('/promowebinar/savepushcrewid/?l=' + currenLocaleObj.locale, { pushcrewid: id }, function(e) {
                    // console.log('pushcrewid sent to sever ' + id);
                    // console.log(e);
                });
            }
        }
    }

    if ($("#phone").length) {
        var telInput = $("#phone"),
            errorMsg = $("#error-msg"),
            validMsg = $("#valid-msg");

        // initialise plugin
        // sets the dropdown to the country th
        telInput.intlTelInput({
            initialCountry: "auto",
            geoIpLookup: function(callback) {
                $.get("https://ipinfo.io", { token: '91df9605e36b3f' }, function() {}, "jsonp").always(function(resp) {
                    var countryCode = resp && resp.country ? resp.country : "";
                    callback(countryCode);
                });
            },
            utilsScript: "/resources/themes/base/thirdpartyjs/utils.js"
        });

        function reset() {
            $(".thankyouSection__mobileForm__errors .message").addClass("hide");
            telInput.removeClass("error");
            errorMsg.addClass("hide");
            validMsg.addClass("hide");
        }

        // on blur: validate
        telInput.blur(function() {
            //console.log("blur");
            showErrorMessages(true);
        });

        function showErrorMessages(checkIfEmpty) {
            reset();
            var condition = checkIfEmpty ? $.trim(telInput.val()) : true;
            if (condition) {
                if (telInput.intlTelInput("isValidNumber")) {
                    validMsg.removeClass("hide");
                } else {
                    telInput.addClass("error");
                    errorMsg.removeClass("hide");
                }
            }
        }

        // on keyup / change flag: reset //
        telInput.on("keyup change", reset);

        var $mobileForm = $(".thankyouSection__mobileForm");
        if ($mobileForm.length) {
            $mobileForm.on("submit", function(e) {
                showErrorMessages(false);
                //console.log("not valid");
                if (telInput.intlTelInput("isValidNumber")) {
                    //console.log("valid");
                    telInput.val(telInput.intlTelInput("getNumber"));
                    //console.log(telInput.intlTelInput("getNumber"));
                    return true;
                }
                //console.log()
                e.preventDefault();
            });
        }

        const registerModal = $('#Form_RegisterForWebinarForm');
        if (registerModal.length) {
            registerModal.on('submit', function(e) {
                if (telInput.val() !== '') {
                    if (telInput.intlTelInput('isValidNumber')) {
                        telInput.removeClass('parsley-error');
                        telInput.val(telInput.intlTelInput('getNumber'));
                    } else {
                        telInput.val('');
                        telInput.attr('placeholder', telInput.data('parsley-error-message'));
                        telInput.addClass('parsley-error');
                        e.preventDefault();
                        return false;
                    }
                }
                return true;
            });
        }

    }

    // REFERRAL PAGE

    $(document).on("touch click", ".js-referralPopup", function(e) {
        e.preventDefault();
        $("#ReferralModal").modal();
    });
    // used to display a facebook error
    if ($('body').data('displaypromotionalwebinarmodal')) {
        $("#RegisterForPromotionalWebinarModal").modal();
    }
});



// WEBPACK FOOTER //
// ./js/modules/promontionalWebinarSystem3.js